











































import { Vue, Component, Emit } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import VueSimpleSuggest from 'vue-simple-suggest'
import { Patient } from '@/types/user'

export type PatientListItem = Pick<
  Patient,
  'firstName' | 'lastName' | 'id' | 'institutions' | 'heartlineId'
> & {
  name: string
}

@Component({
  components: { VueSimpleSuggest }
})
export default class PatientSearchField extends Vue {
  $store!: ExStore
  controls = {
    selectionUp: [38],
    selectionDown: [40],
    select: [],
    showList: [40],
    hideList: [27],
    autocomplete: [32, 13]
  }
  $refs!: {
    searchField: typeof VueSimpleSuggest
  }
  stopAutoSearch = false
  searchWord = ''

  @Emit('select')
  onSelect(patient: PatientListItem | null) {
    return patient ? patient : null
  }

  async getPatientList(): Promise<PatientListItem[]> {
    try {
      const list = (
        await this.$api.user.patientList({
          query: this.searchWord,
          archived: false,
          scope: 'group'
        })
      ).results.map(p => ({
        name: `${p.lastName}${p.firstName}`,
        id: p.id,
        lastName: p.lastName,
        firstName: p.firstName,
        heartlineId: p.heartlineId,
        institutions: p.institutions || []
      }))
      return list
    } catch (e) {
      console.log(e)
      return []
    }
  }

  onCloseClick() {
    this.$refs.searchField?.clearSuggestions()
    this.searchWord = ''
    this.onSelect(null)
  }

  onFocus() {
    this.$refs.searchField?.setText(' ')
  }

  async onChange(searchWord: string) {
    if (this.stopAutoSearch) {
      this.stopAutoSearch = false
      this.$refs.searchField?.hideList()
      return
    }
    this.searchWord = searchWord
    if (searchWord === '') this.$refs.searchField?.clearSuggestions()
  }

  onSelectPatient(patient?: PatientListItem) {
    this.stopAutoSearch = true
    patient ? this.onSelect(patient) : this.onSelect(null)
    this.$refs.searchField?.clearSuggestions()
  }

  selectByEnter() {
    const data = this.$refs.searchField?.hovered
    if (!data) return
    this.stopAutoSearch = true
    this.$refs.searchField?.select(data)
    this.$refs.searchField?.clearSuggestions()
    this.onSelect(data)
  }
}
